import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { Errors } from 'components/ui/errors';

export function RoyaltyScheduleErrors({ errors }) {
  return (
    <Errors
      errors={errors}
      title="There were errors in your input that prevented the royalty schedule from saving."
    />
  );
}

RoyaltyScheduleErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = ({ royaltySchedules }) => ({
  errors: royaltySchedules.errors,
});

export default connect(mapStateToProps)(RoyaltyScheduleErrors);
